module.exports = __webpack_public_path__ + "img/sys-notice.598aaf0a.png";